"use client";
import * as React from "react";
const SvgChangeOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4m3.34-4.2-.88-.87a2.8 2.8 0 0 0-.48-3.3A2.8 2.8 0 0 0 8 5.2h-.07l.87.88-.85.85L5.7 4.66 7.95 2.4l.85.85-.77.77a4 4 0 0 1 2.8 1.15 4 4 0 0 1 .5 5.04m-1.02 1.13L8.05 13.6l-.85-.85.76-.76a4 4 0 0 1-2.78-1.17 4 4 0 0 1-.52-5.03l.88.88a2.8 2.8 0 0 0 .48 3.3 2.8 2.8 0 0 0 2.04.81l-.86-.86.85-.85z" }));
export {
  SvgChangeOutlined as default
};
